import { dmaValidationFormulationDtoSchema } from "./dma-validation-formulation.schema";
export const dmaUpdateValidationFormulationDtoSchema = dmaValidationFormulationDtoSchema
    .omit({
    id: true,
})
    .partial();
